export default __webpack_public_path__ + "static/media/portfolio.775e32fe.png";